import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ChecklistenItemComponent } from './ChecklistenItem/ChecklistenItem';
import { CommonModule } from '@angular/common';
import { ZusatzinformationenComponent } from './Zusatzinformationen/Zusatzinformationen';
import { NotfallrufnummernPopup } from './popups/NotfallrufnummernPopup';
import { HaftungsausschlussPopup } from './popups/HaftungsausschlussPopup';
import { KlinikkennungEingabePopup } from './popups/KlinikkennungEingabePopup';
import { DirectivesModule } from "../directives/directives.module";
import { TeilnehmerInfoComponent } from './TeilnehmerInfo/TeilnehmerInfo';
import { MenuBarIconsComponent } from './MenuBarIcons/MenuBarIcons';
import { RechtlichesComponent } from './Rechtliches/Rechtliches';
import { SuchtrefferListeComponent } from './Suche/SuchtrefferListe';
import { AlphabetischeSucheComponent } from './Suche/AlphabetischeSuche/AlphabetischeSuche';
import { ABCDESucheTabletComponent } from './Suche/ABCDESuche/Tablet/ABCDESuche';
import { ABCDESuchePhoneComponent } from './Suche/ABCDESuche/Phone/ABCDESuche';
import { KoerpernavigatorComponent } from './Suche/Koerpernavigator/Koerpernavigator';
import { TextsucheComponent } from './Suche/Textsuche/Textsuche';
import { ReanimationSucheComponent } from './Suche/Reanimation/Reanimation';
import { PatiententypSelektorComponent } from './Suche/PatiententypSelektor/PatiententypSelektor';
import { SuchtypSelektorComponent } from './Suche/SuchtypSelektor/SuchtypSelektor';


@NgModule({
	declarations: [
		ChecklistenItemComponent,
		ZusatzinformationenComponent,
		NotfallrufnummernPopup,
		KlinikkennungEingabePopup,
		HaftungsausschlussPopup,
		TeilnehmerInfoComponent,
		MenuBarIconsComponent,
		RechtlichesComponent,
		SuchtrefferListeComponent,
		AlphabetischeSucheComponent,
		ABCDESucheTabletComponent,
		ABCDESuchePhoneComponent,
		KoerpernavigatorComponent,
		TextsucheComponent,
		ReanimationSucheComponent,
		PatiententypSelektorComponent,
		SuchtypSelektorComponent
	],
    imports: [
        CommonModule,
        IonicPageModule.forChild(ChecklistenItemComponent), 
        IonicPageModule.forChild(ZusatzinformationenComponent),
        IonicPageModule.forChild(TeilnehmerInfoComponent),
        IonicPageModule.forChild(NotfallrufnummernPopup),
		IonicPageModule.forChild(HaftungsausschlussPopup),
		IonicPageModule.forChild(KlinikkennungEingabePopup),
		IonicPageModule.forChild(MenuBarIconsComponent),
		IonicPageModule.forChild(RechtlichesComponent),
		IonicPageModule.forChild(SuchtrefferListeComponent),
		IonicPageModule.forChild(AlphabetischeSucheComponent),
		IonicPageModule.forChild(ABCDESucheTabletComponent),
		IonicPageModule.forChild(ABCDESuchePhoneComponent),
		IonicPageModule.forChild(KoerpernavigatorComponent),
		IonicPageModule.forChild(TextsucheComponent),
		IonicPageModule.forChild(ReanimationSucheComponent),
		IonicPageModule.forChild(PatiententypSelektorComponent),
		IonicPageModule.forChild(SuchtypSelektorComponent),
        DirectivesModule
    ],
	exports: [
		ChecklistenItemComponent,
		ZusatzinformationenComponent,
		NotfallrufnummernPopup,
		KlinikkennungEingabePopup,
		HaftungsausschlussPopup,
		TeilnehmerInfoComponent,
		MenuBarIconsComponent,
		RechtlichesComponent,
		SuchtrefferListeComponent,
		AlphabetischeSucheComponent,
		ABCDESucheTabletComponent,
		ABCDESuchePhoneComponent,
		KoerpernavigatorComponent,
		TextsucheComponent,
		ReanimationSucheComponent,
		PatiententypSelektorComponent,
		SuchtypSelektorComponent
	]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts